/**
 *
 *  Series of Classes Slider - used in Lifestyle LP
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 2025-08-26.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */
import React from "react";
import Slider from "react-slick";

// Components
import { SliderNextButton } from "../../SliderNextButton/SliderNextButton";
import { SliderPrevButton } from "../../SliderPrevButton/SliderPrevButton";
import { UpcomingClassPlaceholder } from "../UpcomingExperiencesSlider/UpcomingClassPlaceholder/UpcomingClassPlaceholder";

// Hooks
import useTheme from "../../ThemeProvider/useTheme/useTheme";

const sliderResponsiveSettings = [
  {
    breakpoint: 640,
    settings: {
      slidesToShow: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 960,
    settings: {
      slidesToShow: 2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1180,
    settings: {
      slidesToShow: 2,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1400,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 1920,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 2560,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  {
    breakpoint: 5000,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
    },
  },
  { breakpoint: 10000, settings: "unslick" },
];

export const SeriesOfClassesSlider = ({
  className,
  showArrows,
  itemComponent: ItemComponent,
  itemProps,
  sliderAutoplay,
  eventSeries,
  isFetching,
}) => {
  const { theme } = useTheme();

  let content = null;

  const slickInitialised = true;

  if (slickInitialised && (eventSeries?.length || isFetching)) {
    content = (
      <Slider
        className={`${
          className ? `${className} ` : ""
        }future-events-carousel tbk--ml-1 tbk--mr-1 tbk-text-center`}
        dots={true}
        dotsClass={
          "slick-dots !tbk-inline-block tbk--translate-x-1/2 tbk-left-1/2 tbk-whitespace-nowrap"
        }
        arrows={showArrows}
        autoplay={sliderAutoplay}
        autoplaySpeed={4000}
        pauseOnFocus
        pauseOnDotsHover
        pauseOnHover
        infinite={eventSeries?.length > 1}
        speed={500}
        slidesToShow={2}
        slidesToScroll={1}
        initialSlide={0}
        responsive={sliderResponsiveSettings}
        nextArrow={
          <SliderNextButton buttonClassName="tbk-w-[48px] tbk-h-[48px]" />
        }
        prevArrow={
          <SliderPrevButton buttonClassName="tbk-w-[48px] tbk-h-[48px]" />
        }
        // onSwipe={handleSlideSwipe}
      >
        {eventSeries?.length && !isFetching
          ? eventSeries.map((evt, index) => (
              <div
                id={`slide-${index}`}
                className="slide upcoming-experiences-item tbk-pl-1 tbk-pr-1"
                key={index}
                // onClick={() => openGalleryCarouselModal(index)}
              >
                <div className="content slide-bg tbk-h-full tbk-w-full">
                  <ItemComponent item={evt} {...itemProps} />
                </div>
              </div>
            ))
          : isFetching &&
            [...new Array(6)].map((v) => (
              <UpcomingClassPlaceholder
                key={v}
                {...itemProps}
                className={`${className} tbk-pl-1 tbk-pr-1`}
              />
            ))}
      </Slider>
    );
  }

  return content;
};

export default SeriesOfClassesSlider;
